<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header btn-holder tab-nav-holder">
      <div class="col-sm-12 nav-tab-holder">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a (click)="tab$.next(tabs.Calendar)" [class.active]="tab$.value === tabs.Calendar"> Calendar </a>
          </li>
          <li>
            <a (click)="tab$.next(tabs.Basic)" [class.active]="tab$.value === tabs.Basic"> Basic Information </a>
          </li>
          <li
            matTooltip="Specify amenities and other rental values."
            matTooltipClass="text-center"
            matTooltipPosition="below"
          >
            <a (click)="tab$.next(tabs.Info)" [class.active]="tab$.value === tabs.Info"> Detail Information </a>
          </li>
          <li
            matTooltip="Upload images or view images imported from listing channels."
            matTooltipClass="text-center"
            matTooltipPosition="below"
          >
            <a (click)="tab$.next(tabs.Gallery)" [class.active]="tab$.value === tabs.Gallery"> Gallery </a>
          </li>
          <li
            matTooltip="Set the Check-in/Check-out time and add rental details for use with message templates."
            matTooltipPosition="below"
            matTooltipClass="text-center"
          >
            <a (click)="tab$.next(tabs.Instructions)" [class.active]="tab$.value === tabs.Instructions">
              <i
                *ngIf="hasIncompleteCheckInOut"
                matTooltip="This rental has no check-in, check-out or time-zone settings. Please add these details to ensure that any future automations and message templates show the correct times to your guests."
                matTooltipPosition="left"
                matTooltipClass="text-center"
                class="fal fa-exclamation-triangle"
              ></i>
              Rental Instructions
            </a>
          </li>
          <li
            matTooltip="Add rental specific data for use with message templates."
            matTooltipClass="text-center"
            matTooltipPosition="below"
          >
            <a (click)="tab$.next(tabs.Custom)" [class.active]="tab$.value === tabs.Custom"> Custom Information </a>
          </li>
          <li>
            <a (click)="tab$.next(tabs.Location)" [class.active]="tab$.value === tabs.Location"> Location </a>
          </li>
        </ul>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="fas fa-times"></span>
      </a>
    </div>

    <div class="modal-body">
      <div *ngIf="rental" class="tab-content">
        <section [ngSwitch]="tab$.value" class="rental-settings-page">
          <app-rental-rates-calendar
            *ngSwitchCase="tabs.Calendar"
            [rental]="rental"
            [showEvents]="true"
          ></app-rental-rates-calendar>

          <app-rental-details-basic-info *ngSwitchCase="tabs.Basic" [rental]="rental"></app-rental-details-basic-info>

          <app-rental-details-custom-info
            *ngSwitchCase="tabs.Custom"
            [rental]="rental"
          ></app-rental-details-custom-info>

          <app-rental-details-detail-info *ngSwitchCase="tabs.Info" [rental]="rental"></app-rental-details-detail-info>

          <app-rental-details-image-gallery
            *ngSwitchCase="tabs.Gallery"
            [rental]="rental"
            [highlightedItems]="data.highlightedImages"
          ></app-rental-details-image-gallery>

          <app-rental-details-instructions
            *ngSwitchCase="tabs.Instructions"
            [rental]="rental"
          ></app-rental-details-instructions>

          <app-rental-location *ngSwitchCase="tabs.Location" [rental]="rental"></app-rental-location>
        </section>
      </div>
    </div>
  </div>
</div>
